"use strict";
import('./init');
